import LoadingIcons from 'react-loading-icons'
import {Bars} from 'react-loading-icons'
function Loading()
{
    return(

        <div className='text-center m-5 mx-auto'>
                <Bars />
        </div>
    )
}
export default Loading;